import { AutocompleteViewStoreEvent } from 'common/module/autocomplete/view-store.event';
import { AutocompleteViewStoreInterface } from 'common/module/autocomplete/view-store.interface';
import { BuildingReviewLandingAutocompleteStatechartEvent } from 'common/module/building-review-landing/autocomplete/statechart.event';
import { BuildingReviewLandingStrategyInterface } from 'common/module/building-review-landing/strategy.interface';
import { DataStoreOptionsInterface } from 'common/module/data/store/options.interface';
import { StatechartStoreInterface } from 'common/module/statechart/store.interface';

export class BuildingReviewLandingStrategy implements BuildingReviewLandingStrategyInterface {
  /**
   * Constructor
   */
  public constructor(
    private autocompleteService: AutocompleteViewStoreInterface,
    private autocompleteStatechart: StatechartStoreInterface
  ) {}

  /**
   * @inheritdoc
   */
  public initialize(): void {
    this.autocompleteService.getEventEmitter().addListener(AutocompleteViewStoreEvent.clear, this.onClearAutocomplete);
  }

  /**
   * @inheritdoc
   */
  public getAutocompleteOptions(): DataStoreOptionsInterface {
    return {};
  }

  /**
   * Clicked on clear autocomplete button
   */
  private onClearAutocomplete = () => {
    this.autocompleteStatechart.transit({
      event: BuildingReviewLandingAutocompleteStatechartEvent.clearedAutocomplete,
      payload: null,
    });
  };
}
